"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var neat_csv_1 = __importDefault(require("neat-csv"));
var csv_header_1 = require("./csv-header");
var utils_1 = require("./utils");
exports.createObjectEventXml = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedData;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, neat_csv_1.default(data, {
                    // headers: csvObjectEventHeader,
                    // skipLines: 5
                    mapHeaders: function (_a) {
                        var index = _a.index;
                        return csv_header_1.csvObjectEventHeader[index] || null;
                    },
                    skipLines: 4
                })];
            case 1:
                parsedData = (_a.sent());
                return [2 /*return*/, parsedData
                        .map(function (_a, index) {
                        var eventId = _a.eventId, action = _a.action, bizStep = _a.bizStep, informationProvider = _a.informationProvider, productOwner = _a.productOwner, eventTime = _a.eventTime, eventTimeZoneOffset = _a.eventTimeZoneOffset, disposition = _a.disposition, readPoint_id = _a.readPoint_id, bizLocation_id = _a.bizLocation_id, humanWelfarePolicy = _a.humanWelfarePolicy, extension_ilmd_productionMethodForFishAndSeafoodCode = _a.extension_ilmd_productionMethodForFishAndSeafoodCode, rest = __rest(_a, ["eventId", "action", "bizStep", "informationProvider", "productOwner", "eventTime", "eventTimeZoneOffset", "disposition", "readPoint_id", "bizLocation_id", "humanWelfarePolicy", "extension_ilmd_productionMethodForFishAndSeafoodCode"]);
                        if (!action || !eventTime || !informationProvider)
                            return '';
                        var isObserve = action === 'OBSERVE';
                        //#region parse basic lists
                        var epcItemsXml = utils_1.parseCsvColumnList({
                            csvData: parsedData,
                            index: index,
                            indexKey: 'informationProvider',
                            itemKeyList: ['epcList_epc']
                        })
                            .map(function (d) { return "<epc>" + d.epcList_epc + "</epc>"; })
                            .join('\n');
                        var epcListXml = !!epcItemsXml
                            ? "<epcList>" + epcItemsXml + "</epcList>"
                            : '';
                        var bizTransactionItem = utils_1.parseCsvColumnList({
                            csvData: parsedData,
                            index: index,
                            indexKey: 'informationProvider',
                            itemKeyList: [
                                'bizTransactionList_bizTransaction_type',
                                'bizTransactionList_bizTransaction_value'
                            ]
                        })
                            .map(function (d) {
                            return "<bizTransaction type=\"urn:epcglobal:cbv:btt:" + d.bizTransactionList_bizTransaction_type + "\">" + d.bizTransactionList_bizTransaction_value + "</bizTransaction>";
                        })
                            .join('\n');
                        var bizTransactionListXml = !!bizTransactionItem
                            ? "<bizTransactionList>" + bizTransactionItem + "</bizTransactionList>"
                            : '';
                        var sourceListItem = utils_1.parseCsvColumnList({
                            csvData: parsedData,
                            index: index,
                            indexKey: 'informationProvider',
                            itemKeyList: [
                                'extension_sourceList_source_type',
                                'extension_sourceList_source_value'
                            ]
                        })
                            .map(function (d) {
                            return "<source type=\"urn:epcglobal:cbv:sdt:" + d.extension_sourceList_source_type + "\">" + d.extension_sourceList_source_value + "</source>";
                        })
                            .join('\n');
                        var sourceListXml = !!sourceListItem
                            ? "<sourceList>" + sourceListItem + "</sourceList>"
                            : '';
                        var destinationListItem = utils_1.parseCsvColumnList({
                            csvData: parsedData,
                            index: index,
                            indexKey: 'informationProvider',
                            itemKeyList: [
                                'extension_destinationList_destination_type',
                                'extension_destinationList_destination_value'
                            ]
                        })
                            .map(function (d) {
                            return "<destination type=\"urn:epcglobal:cbv:sdt:" + d.extension_destinationList_destination_type + "\">\n              " + d.extension_destinationList_destination_value + "\n            </destination>";
                        })
                            .join('\n');
                        var destinationListXml = !!destinationListItem
                            ? "<destinationList>" + destinationListItem + "</destinationList>"
                            : '';
                        var humanWelfarePolicyXml = !!humanWelfarePolicy
                            ? "<gdst:humanWelfarePolicy>" + humanWelfarePolicy + "</gdst:humanWelfarePolicy>"
                            : '';
                        var quantityListItem = utils_1.parseCsvColumnList({
                            csvData: parsedData,
                            index: index,
                            indexKey: 'informationProvider',
                            itemKeyList: [
                                'extension_quantityList_quantityElement_epcClass',
                                'extension_quantityList_quantityElement_quantity',
                                'extension_quantityList_quantityElement_uom'
                            ]
                        })
                            .map(function (d) { return "<quantityElement>\n<epcClass>" + d.extension_quantityList_quantityElement_epcClass + "</epcClass>\n<quantity>" + d.extension_quantityList_quantityElement_quantity + "</quantity>\n<uom>" + d.extension_quantityList_quantityElement_uom + "</uom>\n</quantityElement>"; })
                            .join('\n');
                        var quantityListXml = !!quantityListItem
                            ? "<quantityList>" + quantityListItem + "</quantityList>"
                            : '';
                        //#endregion
                        var cbvmdaItemsXml = [
                            'transshipStartDate',
                            'transshipEndDate',
                            'landingEndDate',
                            'landingStartDate'
                        ]
                            .filter(function (k) { return !!rest[k]; })
                            .map(function (k) { return "<cbvmda:" + k + ">" + rest[k] + "</cbvmda:" + k + ">"; })
                            .join('\n');
                        //#region parse ilmd
                        var ilmdCbvmdaItemsXml = [
                            'unloadingPort',
                            'harvestEndDate',
                            'harvestStartDate'
                        ]
                            .filter(function (k) { return !!rest["extension_ilmd_" + k]; })
                            .map(function (k) { return "<cbvmda:" + k + ">" + rest["extension_ilmd_" + k] + "</cbvmda:" + k + ">"; })
                            .join('\n');
                        var ilmdGdstItemsXml = ['broodstockSource']
                            .filter(function (k) { return !!rest["extension_ilmd_" + k]; })
                            .map(function (k) { return "<gdst:" + k + ">" + rest["extension_ilmd_" + k] + "</gdst:" + k + ">"; })
                            .join('\n');
                        var ilmdProductionMethodXml = !!extension_ilmd_productionMethodForFishAndSeafoodCode
                            ? "<productionMethodForFishAndSeafoodCode>" + extension_ilmd_productionMethodForFishAndSeafoodCode + "</productionMethodForFishAndSeafoodCode>"
                            : '';
                        var ilmdVesselCatchInformationItemsXml = utils_1.parseCsvColumnList({
                            csvData: parsedData,
                            index: index,
                            indexKey: 'informationProvider',
                            itemKeyList: [
                                'extension_ilmd_vesselCatchInformationList_vesselCatchInformation_catchArea',
                                'extension_ilmd_vesselCatchInformationList_vesselCatchInformation_rmfoArea',
                                'extension_ilmd_vesselCatchInformationList_vesselCatchInformation_economicZone',
                                'extension_ilmd_vesselCatchInformationList_vesselCatchInformation_subnationalPermitArea',
                                'extension_ilmd_vesselCatchInformationList_vesselCatchInformation_fishingGearTypeCode',
                                'extension_ilmd_vesselCatchInformationList_vesselCatchInformation_vesselFlagState',
                                'extension_ilmd_vesselCatchInformationList_vesselCatchInformation_vesselID',
                                'extension_ilmd_vesselCatchInformationList_vesselCatchInformation_vesselName',
                                'extension_ilmd_vesselCatchInformationList_vesselCatchInformation_gpsAvailability',
                                'extension_ilmd_vesselCatchInformationList_vesselCatchInformation_vesselPublicRegistry',
                                'extension_ilmd_vesselCatchInformationList_vesselCatchInformation_satelliteTrackingAuthority',
                                'extension_ilmd_vesselCatchInformationList_vesselCatchInformation_fisheryImprovementProject',
                                'extension_ilmd_vesselCatchInformationList_vesselCatchInformation_imoNumber'
                            ]
                        })
                            .map(function (d) { return "<cbvmda:vesselCatchInformation>\n<cbvmda:vesselName>" + d.extension_ilmd_vesselCatchInformationList_vesselCatchInformation_vesselName + "</cbvmda:vesselName>\n<cbvmda:vesselID>" + d.extension_ilmd_vesselCatchInformationList_vesselCatchInformation_vesselID + "</cbvmda:vesselID>\n<gdst:imoNumber>" + d.extension_ilmd_vesselCatchInformationList_vesselCatchInformation_imoNumber + "</gdst:imoNumber>\n<cbvmda:vesselFlagState>" + d.extension_ilmd_vesselCatchInformationList_vesselCatchInformation_vesselFlagState + "</cbvmda:vesselFlagState>\n<gdst:vesselPublicRegistry>" + d.extension_ilmd_vesselCatchInformationList_vesselCatchInformation_vesselPublicRegistry + "</gdst:vesselPublicRegistry>\n<gdst:gpsAvailability>" + d.extension_ilmd_vesselCatchInformationList_vesselCatchInformation_gpsAvailability + "</gdst:gpsAvailability>\n<gdst:satelliteTrackingAuthority>" + d.extension_ilmd_vesselCatchInformationList_vesselCatchInformation_satelliteTrackingAuthority + "</gdst:satelliteTrackingAuthority>\n<cbvmda:economicZone>" + d.extension_ilmd_vesselCatchInformationList_vesselCatchInformation_economicZone + "</cbvmda:economicZone>\n<gdst:fisheryImprovementProject>" + d.extension_ilmd_vesselCatchInformationList_vesselCatchInformation_fisheryImprovementProject + "</gdst:fisheryImprovementProject>\n<gdst:rmfoArea>" + d.extension_ilmd_vesselCatchInformationList_vesselCatchInformation_rmfoArea + "</gdst:rmfoArea>\n<gdst:subnationalPermitArea>" + d.extension_ilmd_vesselCatchInformationList_vesselCatchInformation_subnationalPermitArea + "</gdst:subnationalPermitArea>\n<cbvmda:catchArea>" + d.extension_ilmd_vesselCatchInformationList_vesselCatchInformation_catchArea + "</cbvmda:catchArea>\n<cbvmda:fishingGearTypeCode>" + d.extension_ilmd_vesselCatchInformationList_vesselCatchInformation_fishingGearTypeCode + "</cbvmda:fishingGearTypeCode>\n</cbvmda:vesselCatchInformation>"; })
                            .join('\n')
                            .trim();
                        var ilmdVesselCatchInformationListXml = !!ilmdVesselCatchInformationItemsXml
                            ? "<cbvmda:vesselCatchInformationList>" + ilmdVesselCatchInformationItemsXml + "</cbvmda:vesselCatchInformationList>"
                            : '';
                        var certificationItemsXml = utils_1.parseCsvColumnList({
                            csvData: parsedData,
                            index: index,
                            indexKey: 'informationProvider',
                            itemKeyList: [
                                'extension_ilmd_certificationList_certification_certificationType',
                                'extension_ilmd_certificationList_certification_certificationAgency',
                                'extension_ilmd_certificationList_certification_certificationIdentification',
                                'extension_ilmd_certificationList_certification_certificationStandard',
                                'extension_ilmd_certificationList_certification_certificationValue'
                            ]
                        })
                            .map(function (d) { return "<cbvmda:certification>\n<gdst:certificateType>" + d.extension_ilmd_certificationList_certification_certificationType + "</gdst:certificateType>\n<cbvmda:certificationStandard>" + d.extension_ilmd_certificationList_certification_certificationStandard + "</cbvmda:certificationStandard> \n<cbvmda:certificationAgency>" + d.extension_ilmd_certificationList_certification_certificationAgency + "</cbvmda:certificationAgency>\n<cbvmda:certificationValue>" + d.extension_ilmd_certificationList_certification_certificationValue + "</cbvmda:certificationValue>\n<cbvmda:certificationIdentification>" + d.extension_ilmd_certificationList_certification_certificationIdentification + "</cbvmda:certificationIdentification>\n</cbvmda:certification>"; })
                            .join('\n')
                            .trim();
                        var certificationXml = !!certificationItemsXml
                            ? isObserve
                                ? "<gdst:certificationList>" + certificationItemsXml + "</gdst:certificationList>"
                                : "<cbvmda:certificationList>" + certificationItemsXml + "</cbvmda:certificationList>"
                            : '';
                        var ilmdItemsXml = [
                            ilmdGdstItemsXml,
                            ilmdVesselCatchInformationListXml,
                            ilmdProductionMethodXml,
                            ilmdCbvmdaItemsXml,
                            !isObserve ? certificationXml : ''
                        ]
                            .join('\n')
                            .trim();
                        var ilmdXml = !!ilmdItemsXml
                            ? "<ilmd>\n          " + ilmdItemsXml + "\n        </ilmd>"
                            : '';
                        //#endregion
                        var extensionItemsXml = [
                            quantityListXml,
                            sourceListXml,
                            destinationListXml,
                            ilmdXml
                        ].join('\n');
                        var extensionXml = !!extensionItemsXml
                            ? "<extension>" + extensionItemsXml + "</extension>"
                            : '';
                        var bizStepXml = !!bizStep
                            ? "<bizStep>" + bizStep + "</bizStep>"
                            : '<bizStep></bizStep>';
                        var dispositionXml = !!disposition
                            ? "<disposition>urn:epcglobal:cbv:disp:" + disposition + "</disposition>"
                            : '<disposition></disposition>';
                        return {
                            date: new Date(eventTime + "Z" + eventTimeZoneOffset),
                            xml: "<ObjectEvent>\n<eventTime>" + eventTime + "</eventTime> \n<eventTimeZoneOffset>" + eventTimeZoneOffset + "</eventTimeZoneOffset>\n<baseExtension>\n  <eventID>" + eventId + "</eventID>\n</baseExtension>\n" + epcListXml + "\n<action>" + action + "</action>\n\n" + bizStepXml + "\n" + dispositionXml + "\n\n<readPoint><id>" + readPoint_id + "</id></readPoint>\n<bizLocation><id>" + bizLocation_id + "</id></bizLocation>\n\n" + bizTransactionListXml + "\n\n" + (isObserve ? certificationXml : '') + "\n" + cbvmdaItemsXml + "\n\n" + extensionXml + "\n" + humanWelfarePolicyXml + "\n<gdst:productOwner>" + productOwner + "</gdst:productOwner>\n<cbvmda:informationProvider>" + informationProvider + "</cbvmda:informationProvider> \n</ObjectEvent>"
                        };
                    })
                        .filter(function (t) { return !!t.xml; })];
        }
    });
}); };
//# sourceMappingURL=object-event.js.map